var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M14.2969 9.81745L14.8744 9.23987C16.4378 7.67655 18.9708 7.67655 20.5341 9.23987L26.554 15.2597C28.4895 17.1952 28.4895 20.3325 26.554 22.268L26.2592 22.5628C24.3237 24.4982 21.1864 24.4982 19.2509 22.5628L14.565 17.8768",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M7.33251 19.3522C5.36235 18.3678 3.99512 16.3523 3.99512 13.9993C3.99512 10.6846 6.6829 7.99683 9.99762 7.99683C13.3123 7.99683 16.0001 10.6846 16.0001 13.9993C16.0001 16.351 14.6342 18.3665 12.6654 19.3509V19.3482L12.6641 25.3427C12.6627 25.6949 12.5227 26.0323 12.2732 26.2804L10.9367 27.617C10.4165 28.1359 9.57611 28.1345 9.05723 27.6157L7.71934 26.2751C7.4699 26.0257 7.32984 25.6869 7.32984 25.3347L7.33251 19.3496",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M9.99805 13.6658V7.66331C9.99805 5.63713 11.6401 3.99512 13.6662 3.99512V3.99512C15.6924 3.99512 17.3344 5.63713 17.3344 7.66331V8.08615",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M9.99633 13.6657C9.81225 13.6657 9.66285 13.8151 9.66552 13.9992C9.66552 14.1833 9.81492 14.3327 9.99899 14.3327C10.1831 14.3327 10.3325 14.1833 10.3325 13.9992C10.3311 13.8151 10.1817 13.6657 9.99633 13.6657",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyreview);
export default __webpack_public_path__ + "static/media/keyreview.b71ba73dd612af3330d52127b03ceb55.svg";
export { ForwardRef as ReactComponent };